import { isCompetitionEnded } from "@/server/helpers/general";
import { getMyCompetitions } from "./api";

export async function getSingleActiveCompetitionPath(): Promise<string | null> {
  const { data, error } = await getMyCompetitions();
  if (error || !data) return null;

  const active = data.items.filter((c) => !isCompetitionEnded(c.endsAt, c.timezone));
  if (active.length === 1) {
    return `/competition/${active[0].id}`;
  }

  return null;
}
